"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var common_1 = require("./../common");
var useContext = React.useContext, useState = React.useState;
exports.default = (function (props) {
    var onClose = props.onClose, onNewProduct = props.onNewProduct;
    return (React.createElement(common_1.ModalWrapper, { isOpen: true, onClose: onClose, style: { maxWidth: "450px" } },
        React.createElement("div", { className: "rounded-corner p-3 py-md-5 bg-white my-3 my-md-4 position-relative" },
            React.createElement("span", { className: "icon-indicator cart center" }),
            React.createElement("h4", { className: "text-center mb-0" }, "Product has been added to your cart!")),
        React.createElement("h4", { className: "text-center my-4" }, "What would you like to do now?"),
        React.createElement("div", { className: "text-center" },
            React.createElement("button", { className: "btn btn-primary mx-2", onClick: onNewProduct }, "Create New"),
            React.createElement(common_1.Button, { variant: "pink", className: "mx-2", onClick: function () { return (window.location.href = "/cart"); }, content: "View Cart" }))));
});
